import { useLocation } from 'react-router-dom';

import Button from '@/components/Button/Button';
import CustomImage from '@/components/CustomImage';
import { useFormatText } from '@/hooks/useFormatText';

const CheckYourEmail = () => {
  const { formatText } = useFormatText();
  const { state } = useLocation();
  const email = state?.email;

  return (
    <div className="flex flex-col justify-center p-15 md:p-10 w-full lg:max-w-150">
      <div className="w-full h-full flex flex-col items-center my-auto space-y-10">
        <div>
          <p className="pb-2 text-center leading-[-0.36px] text-4xl max-md:text-3xl font-bold text-neutral-primary">
            {formatText('check-email.title')}
          </p>
          <div className="text-neutral-secondary text-center text-lg font-medium">
            {formatText('check-email.message')}{' '}
            <span className="text-neutral-primary font-semibold">{email}</span>
          </div>
        </div>
        <CustomImage
          src={'/assets/svg/mail.svg'}
          alt={'Mail Illustration'}
          className="w-25 h-25"
        />
        <Button
          label={formatText('check-email.actions.open-email')}
          variant="primary"
          className="w-full py-3.5! leading-5"
          onClick={() => window.open('https://mail.google.com', '_blank')}
        />
      </div>
    </div>
  );
};

export default CheckYourEmail;
